<script setup lang="ts">
const props = defineProps<{
  isMobile?: boolean
}>()

function toggleSearch() {
  if (searching.value) {
    searching.value = false
  } else {
    searching.value = true
  }
}

const searching = defineModel<boolean>()
</script>

<template>
  <div class="flex cursor-pointer items-center gap-1" @click="toggleSearch">
    <template v-if="!props.isMobile">
      <UiAnimatedUnderlineText>
        <div class="text-sm" :class="{ 'text-xl': props.isMobile }">
          {{ $t('base.search.title') }}
        </div>
      </UiAnimatedUnderlineText>
    </template>
    <IconFind
      v-if="!searching"
      :class="props.isMobile ? 'text-3xl' : 'w-3 text-sm'"
    ></IconFind>
    <IconClose
      v-else
      :class="props.isMobile ? 'text-3xl' : 'w-3 text-sm'"
    ></IconClose>
  </div>
</template>

<style scoped></style>
